module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Rectangle_346241932@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FRectangle_346241932%402x.png
// module id = o5gy
// module chunks = 93